import TableWithErrorHandling from "components/components/TableWithErrorHandling/TableWithErrorHandling";
import DerivedDataTable from "components/dataVisualization/DerivedData/DerivedDataTable/DerivedDataTable";
import {
  mapIndicativeCashflowData,
  pairHeaders,
} from "components/dataVisualization/DerivedData/utils";
import { RequestStatus } from "hooks/useRequest";
import {
  IndicativeCashflowModel,
  IndicativeCashflowRow,
} from "models/derivedData/indicativeCashflow";
import { useCallback, useMemo } from "react";
import { combineRequestStatuses } from "utils/requestHelpers";

interface Props {
  bidRequest: {
    fetchData: () => void;
    data: IndicativeCashflowModel[] | null;
    status: RequestStatus;
  };
  offerRequest: {
    fetchData: () => void;
    data: IndicativeCashflowModel[] | null;
    status: RequestStatus;
  };
}

const IndicativeCashflowTab: React.FC<Props> = ({
  bidRequest: { data: rawBidData, fetchData: fetchBidData, status: bidStatus },
  offerRequest: {
    data: rawOfferData,
    fetchData: fetchOfferData,
    status: offerStatus,
  },
}) => {
  const fetchData = useCallback((): void => {
    fetchBidData();
    fetchOfferData();
  }, [fetchBidData, fetchOfferData]);

  const mappedData = useMemo(
    () => mapIndicativeCashflowData(rawBidData, rawOfferData),
    [rawBidData, rawOfferData]
  );

  const status = combineRequestStatuses(bidStatus, offerStatus);

  return (
    <TableWithErrorHandling
      data={mappedData}
      dataFetchStatus={status}
      rerequestData={fetchData}
      aria-label="indicative-cashflow-table"
    >
      <DerivedDataTable<IndicativeCashflowRow>
        headers={{
          bmUnit: "BMU ID",
          leadPartyName: "Lead Party Name",
          totalCashflow: "Total Cashflow",
          bidOffer: "Bid/Offer",
          ...pairHeaders,
          bmUnitType: "BMU Type",
          nationalGridBmUnit: "NG BMU Name",
        }}
        mappedData={mappedData}
      />
    </TableWithErrorHandling>
  );
};

export default IndicativeCashflowTab;
